import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core'
import { Link, useLocation } from 'react-router-dom'
import './MatchTeamToggle.css'

const MatchTeamToggle = () => {
  const { pathname } = useLocation()

  return (
    <div className="matchTeamToggle">
      <RadioGroup
        aria-label="Match Or Team"
        name="matchTeamToggle"
        value={pathname.replace('/', '')}
      >
        <Link to="/match">
          <FormControlLabel
            value="match"
            control={<Radio color="primary" />}
            label="Match"
          />
        </Link>
        <Link to="/team">
          <FormControlLabel
            value="team"
            control={<Radio color="primary" />}
            label="Team"
          />
        </Link>
      </RadioGroup>
    </div>
  )
}

export default MatchTeamToggle
